import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import style from '../../style'
import GroupTable from '../../partials/GroupTable'
import Container from '../../partials/Container'

import user from '../../../../utils/user'
import access from '../../../../utils/access'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Community', 'Auth', 'User', 'Config')
@observer
export class CommunityGroup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        enabled: false
      },
      active: {}
    }
  }

  componentWillMount () {
    const comId = this.props.match.params.comId
    const _searchApplications = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending) {
          return _searchApplications()
        }

        Promise.all([
          ...(!this.props.Community.all.slice().find(c => c.id === comId)
            ? [this.props.Community.getCommunity(comId)]
            : [])
        ]).catch(() => this.props.history.push(`/dashboard/community`))
      }, 500)
    }

    _searchApplications()
  }

  onCreateClick (e) {
    e.preventDefault()
    return this.props.history.push(`${this.props.location.pathname}/new`)
  }

  onGroupExpand (index) {
    if (this.state.editor.enabled) {
      return this.props.history.push(`${this.props.location.pathname}/${index}`)
    }

    this.setState({
      ...this.state,
      active: {
        ...this.state.active,
        id: this.state.active.id === index ? null : index
      }
    })
  }

  onGroupEditClick () {
    if (this.state.active.id) {
      return this.props.history.push(
        `${this.props.location.pathname}/${this.state.active.id}`
      )
    }

    this.setState({
      ...this.state,
      active: {
        ...this.state.active,
        id: null
      },
      editor: {
        ...this.state.editor,
        enabled: !this.state.editor.enabled
      }
    })
  }

  render () {
    const comId = this.props.match.params.comId
    const userGroups = (this.props.Community.groups[comId] || [])
      .slice()
      .reduce(
        (arr, g) => [
          ...arr,
          ...(g.users.includes(this.props.Auth.token.userId) ? [g] : [])
        ],
        []
      )
    const userPerms = user.parsePermList({ groups: userGroups })

    return (
      <Container {...this.props}>
        <Row>
          <Col>
            <Row>
              <Col xs='12' lg='6'>
                <h2 className={css(style.headers.h2)}>Community Groups</h2>
              </Col>
              <Col>
                {!access.comGroup(userPerms) &&
                !access.adminCom(
                  this.props.User.me.permissions || {}
                ) ? null : (
                  <Row>
                    <Col>
                      <span
                        className={css(
                          style.buttons.button,
                          style.buttons.red,
                          this.state.editor.enabled
                            ? style.buttons.redActive
                            : null
                        )}
                        onClick={this.onGroupEditClick.bind(this)}
                      >
                        Edit
                      </span>
                    </Col>
                    <Col>
                      <span
                        className={css(style.buttons.button, style.buttons.red)}
                        onClick={this.onCreateClick.bind(this)}
                      >
                        Add new
                      </span>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <GroupTable
            theme={THEME_LIST[this.props.Config.theme]}
            groups={(this.props.Community.groups[comId] || []).slice()}
            users={(this.props.Community.users[comId] || []).slice()}
            activeGroup={this.state.active}
            onGroupExpand={this.onGroupExpand.bind(this)}
          />
        </Row>
      </Container>
    )
  }
}

export default CommunityGroup



// WEBPACK FOOTER //
// ./src/components/Community/Group/Main/index.js